import { EOSService } from "../../api/eos-service";
import { ExtraWorkService } from "../../api/extra-work-service";

const state = {};

const getters = {};

const actions = {
    async InsertExtraWork(state, { params }) {
        var perno = state.rootState.auth.auth.username;
        params.append('perno', perno);
        return await EOSService.makeRequest(ExtraWorkService.InsertExtraWork(params))
    },
    async UpdateExtraWork(state, { params }) {
        if (!params.get('perno')) {
            var perno = state.rootState.auth.auth.username;
            params.append('perno', perno);
        }
        return await EOSService.makeRequest(ExtraWorkService.UpdateExtraWork(params))
    },
    async GetExtraWork(state, { GetExtraWorkParams }) {
        //beginDate=1400/09/01&endDate=1400/09/29&status=1=1&sortType=desc&sortExpression=begindate&pageNumber=1&pagesize=20
        var params = new URLSearchParams()
        if (!GetExtraWorkParams.perno) {
            var perno = state.rootState.auth.auth.username;
            params.append('perno', perno);
        } else{
            params.append('perno', GetExtraWorkParams.perno);
        }
        params.append('status', GetExtraWorkParams.status);
        //params.append('searchKind',GetExtraWorkParams.status);
        params.append('sortType', 'desc');
        params.append('sortExpression', 'begindate');
        params.append('beginDate', GetExtraWorkParams.beginDate);
        params.append('endDate', GetExtraWorkParams.endDate);
        params.append('pageNumber', GetExtraWorkParams.page);
        params.append('pagesize', GetExtraWorkParams.pagesize);

        return await EOSService.makeRequest(ExtraWorkService.GetExtraWork(params))
        /*const response =  await ExtraWorkService.GetExtraWork(params)
        if(response.data){
            return Result.success(response.data);
        } else{
            return Result.error()
        }*/
    },
    async GetPersonSpecificEw(state, { GetPersonSpecificEwParams }) {
        //perno=1032&status=status = 10&sortType=Desc&sortExpression=RecDate&pageNumber=1&pageSize=20&periodItem= 
        var params = new URLSearchParams()
        var perno = state.rootState.auth.auth.username;
        params.append('perno', perno);
        params.append('status', GetPersonSpecificEwParams.status);
        params.append('sortType', 'desc');
        params.append('sortExpression', 'RecDate');
        params.append('pageNumber', GetPersonSpecificEwParams.page);
        params.append('pagesize', GetPersonSpecificEwParams.pagesize);
        params.append('periodItem', GetPersonSpecificEwParams.periodItem);

        return await EOSService.makeRequest(ExtraWorkService.GetPersonSpecificEw(params))
    },
    async GetExtraWorkDetail(state, { params }) {
        if (!params.get('perno')) {
            var perno = state.rootState.auth.auth.username;
            params.append('perno', perno);
        }
        return await EOSService.makeRequest(ExtraWorkService.GetExtraWorkDetail(params))
    },
    async OprationOnExtraWorkRequest(state, { params }) {
        var perno = state.rootState.auth.auth.username;
        params['perno'] = perno;
        return await EOSService.makeRequest(ExtraWorkService.OprationOnRequest(params))
    },
    async GetExtraWorkListForAdmin(state, { params }) {
        //debugger;
        var perno = state.rootState.auth.auth.username;
        params['adminPerno'] = perno;
        params['status'] = '1=1';
        return await EOSService.makeRequest(ExtraWorkService.GetExtraWorkListForAdmin(params))
        
    },
    async GetExtraWorkApproveDegree(state, { approveParams }) {
        var perno = state.rootState.auth.auth.username;
        approveParams['adminPerno'] = perno;
        return await EOSService.makeRequest(ExtraWorkService.GetExtraWorkApproveDegree(approveParams))
    },
    /**
     * specific extra work
     */
    async GetSpecificEWListForAdmins(state, { params }) {
        var perno = state.rootState.auth.auth.username;
        params['adminPerno'] = perno;
        //params['status'] = '1=1';
        params['sortType'] = 'desc';
        params['sortExpression'] = 'perno';
        params['pageNumber'] = '1';
        params['pageSize'] = '2000';

        return await EOSService.makeRequest(ExtraWorkService.GetSpecificEWListForAdmins(params))
    },
    async GetSpecificEwDetailForPerson(state, { params }) {
        return await EOSService.makeRequest(ExtraWorkService.GetSpecificEwDetailForPerson(params))
    },
    async GetSpecificExtraWorkAmountForSection(state, { params }) {
        return await EOSService.makeRequest(ExtraWorkService.GetSpecificExtraWorkAmountForSection(params))
    },
    async GetPersonByExtraWorkBySection(state, { params }) {
        var perno = state.rootState.auth.auth.username;
        params.append('perno', perno);
        return await EOSService.makeRequest(ExtraWorkService.GetPersonByExtraWorkBySection(params))
    },
    async InsertOrUpdateSpecialEW(state, { params }) {
        var perno = state.rootState.auth.auth.username;
        params.append('approvedby', perno);
        return await EOSService.makeRequest(ExtraWorkService.InsertOrUpdateSpecialEW(params))
    },
    async GetExtraWorkDetailForAdmin(state, { params }) {
        var perno = state.rootState.auth.auth.username;
        params.append('adminPerno', perno);
        return await EOSService.makeRequest(ExtraWorkService.GetExtraWorkDetailForAdmin(params))
    },
};

const mutations = {
};

export default {
    state,
    getters,
    actions,
    mutations
}